import React from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { useCashierSession } from "./CasierHistoryContext";
import CashierHistoryTable from "./components/CashierHistoryTable";

const CashierHistoryPage = () => {
  const { cashierSessions, Pagination, refetchCashierSessions } = useCashierSession();

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-4">
        <CashierHistoryTable 
          data={cashierSessions} 
          Pagination={Pagination} 
          refetch={refetchCashierSessions}
        />
      </div>
    </LayoutDashboard>
  );
};

export default CashierHistoryPage;
